import type { LucideIcon } from "lucide-react";
import {
  LayoutGrid,
  Users,
  CreditCard,
  Wallet,
  LineChart,
  ListChecks,
  Receipt,
  RefreshCw,
  UserCog,
  UserRound,
  Settings,
  Archive,
} from "lucide-react";

export type NavGroup = "operations" | "finance" | "team";

export interface NavItem {
  /** route path under "/" */
  to: string;
  /** i18n key for the label */
  labelKey: string;
  /** fallback label (FR) */
  label: string;
  icon: LucideIcon;
  group: NavGroup;
  /** optional permission key required to see this item */
  permission?: string;
  /** when true, only OWNER/ADMIN/MANAGER can see this item */
  adminOnly?: boolean;
  /** when set, user must have one of these roles (overrides permission-based access) */
  restrictRoles?: string[];
  badge?: { value: number; tone: "primary" | "danger" };
}

export const NAV_ITEMS: NavItem[] = [
  { to: "/dashboard", labelKey: "nav.dashboard", label: "Tableau de bord", icon: LayoutGrid, group: "operations", adminOnly: true },
  { to: "/clients", labelKey: "nav.clients", label: "Clients", icon: Users, group: "operations", permission: "clients.view" },
  { to: "/payments", labelKey: "nav.payments", label: "Paiements", icon: CreditCard, group: "operations", permission: "payments.view", restrictRoles: ["OWNER", "ADMIN", "MANAGER", "ACCOUNTANT"] },
  { to: "/wallets", labelKey: "nav.wallets", label: "Portefeuilles", icon: Wallet, group: "operations", permission: "wallets.view", restrictRoles: ["OWNER", "ADMIN", "MANAGER", "ACCOUNTANT"] },
  { to: "/ad-spend", labelKey: "nav.adSpend", label: "Dépenses pub", icon: LineChart, group: "operations", permission: "ad-spend.view" },
  { to: "/tasks", labelKey: "nav.tasks", label: "Tâches", icon: ListChecks, group: "operations", permission: "tasks.view" },
  { to: "/profile", labelKey: "nav.profile", label: "Mon profil", icon: UserRound, group: "operations" },
  { to: "/expenses", labelKey: "nav.expenses", label: "Dépenses", icon: Receipt, group: "finance", permission: "expenses.view", restrictRoles: ["OWNER", "ADMIN", "MANAGER", "ACCOUNTANT"] },
  { to: "/subscriptions", labelKey: "nav.subscriptions", label: "Abonnements", icon: RefreshCw, group: "finance", permission: "subscriptions.view", restrictRoles: ["OWNER", "ADMIN", "MANAGER", "ACCOUNTANT"] },
  { to: "/archives", labelKey: "nav.archives", label: "Archives", icon: Archive, group: "finance", adminOnly: true },
  { to: "/team", labelKey: "nav.team", label: "Équipe", icon: UserCog, group: "team", permission: "team.view" },
  { to: "/settings", labelKey: "nav.settings", label: "Paramètres", icon: Settings, group: "team", permission: "settings.view" },
];

export const NAV_GROUP_LABELS: Record<NavGroup, { key: string; label: string }> = {
  operations: { key: "nav.group.operations", label: "Opérations" },
  finance: { key: "nav.group.finance", label: "Finance" },
  team: { key: "nav.group.team", label: "Équipe" },
};

export const DEFAULT_EXCHANGE_RATE = 218.5;
export const WALLET_ALERT_THRESHOLD_USD = 150;

export const AGENCY = {
  name: "Fad Agency",
  slug: "fad-agency",
  email: "contact@fadagency.dz",
};
